import getAxiosInstance from '../../../../../helpers/get_axios_instance'
import lrsAdapter from '../../../../../helpers/lrs_adapter'

export class TablaConsultaCumplimientoDeCuposService {
  static getCumplimientoCuposVigente () {
    const axios = getAxiosInstance()
    const orden = '{"orden":["fecha_cupo"]}'
    const promise = axios.get(`/estadistica_cumplimiento_cupo_vigente?r=${orden}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then(result => result.data)
      .catch(lrsAdapter)
  }

  static getCumplimientoCuposAsignados (fechaDesde, fechaHasta) {
    const axios = getAxiosInstance()
    const orden = '"orden":["fecha_cupo"]'
    const filtro = `{"clave":{"fecha_desde": "${fechaDesde}", "fecha_hasta": "${fechaHasta}"}, ${orden}}`
    const promise = axios.get(`/estadistica_cumplimiento_cupo_asignado?r=${filtro}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then(result => result.data)
      .catch(lrsAdapter)
  }

  static async getEstadisticaCuposNominables (fechaDesde, fechaHasta) {
    const axios = getAxiosInstance()
    const orden = '"orden":["fecha_cupo"]'
    const filtro = `{"clave":{"fecha_desde": "${fechaDesde}", "fecha_hasta": "${fechaHasta}"}, ${orden}}`
    const promise = axios.get(`estadistica_cumplimiento_cupo_nominable?r=${filtro}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then(result => result.data)
      .catch(lrsAdapter)
  }
}
